export default __webpack_public_path__ + "static/media/under-review-icon@3x.ca9a0b7f.png";